import { t as f } from "../../../index.esm-BnSuefUA.js";
import { s as c } from "../../../Popover.module-DJ-RK5B3.js";
import { FOCUSABLE_QUERY_SELECTOR as l } from "../../../constants.js";
import { focusableElements as m } from "../../../helpers/dom/focusableElements.js";
import { waitUntilTrue as u } from "./waitUntilTrue.js";
const g = async (n, s) => {
  if (s.key !== "Tab")
    return;
  const o = n.api.elements.reference;
  if (!o)
    return;
  let t = o;
  if (!t.matches(l)) {
    const e = m(o);
    t = e[e.length - 1];
  }
  if (s.shiftKey && (n.setShow(!1), t.focus()), !s.shiftKey) {
    n.setShowWithReason(!1);
    const e = f(document.documentElement).filter(
      (i) => !i.closest(`.${c.content}`) && !i.hasAttribute("data-floating-ui-focus-guard")
    ), a = e.indexOf(t), r = e[a + 1];
    if (a === -1 || !r) return;
    await u(
      () => !r.hasAttribute("data-floating-ui-inert")
    ), r.focus();
  }
};
export {
  g as handlePopoverTabKey
};
